import React, { useState } from 'react';
import { Dialog, useMediaQuery } from '@material-ui/core';
import useStyles from './12Tren.style';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import UndoRoundedIcon from '@mui/icons-material/UndoRounded';
import _ from 'lodash';
import { DISCOUNT_ICON_2, COPY_ICON, WEB_ICON } from 'images/GoogleCloud';
import { TREN_IMAGE } from 'images/GCP';
import { useDiscountCode } from 'apollo/discount_codes';

interface CongratsModalProps {
  open: boolean;
  setOpen12Tren: (value: boolean) => void;
}

export const Tren: React.FC<CongratsModalProps> = ({ open, setOpen12Tren }) => {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width: 1240px)');
  const { discountCode } = useDiscountCode('12Tren');
  const [copied, setCopied] = useState(false);
  const handleCopyButton = () => {
    navigator.clipboard.writeText(discountCode.code);
    setCopied(true);
  };
  return (
    <>
      {!isMobile ? (
        <Dialog
          open={open}
          onClose={() => setOpen12Tren(false)}
          className={classes.Dialog}
          id='outer-div'
        >
          <div className={classes.container}>
            <div className={classes.bottomBackButtonContainer}>
              <img src={TREN_IMAGE} className={classes.image} />
              <div
                className={classes.closeButtonContainer}
                onClick={() => setOpen12Tren(false)}
              >
                <ArrowBackIosNewRoundedIcon className={classes.iconback} />
              </div>
            </div>
            <div className={classes.container2}>
              <p className={classes.titleText}>12tren.com</p>
              <p className={classes.infoText}>
                En 12tren podrás mejorar tu salud financiera
                <strong> comprando directamente a las fábricas</strong>, y
                evitando así los precios de supermercados. ¡Aquí podrás
                encontrar un descuento exclusivo por ser parte de la comunidad
                Rokin!
              </p>
              <div className={classes.descuentoConteiner}>
                <div className={classes.pasosContainer}>
                  <p className={classes.pasosText2}>
                    {' '}
                    ¿Cómo ocupo mi descuento Rokin?
                  </p>
                  <div className={classes.paso}>
                    <img src={COPY_ICON} className={classes.icon} />
                    <p className={classes.pasosText}>
                      Copia el código de descuento
                    </p>
                  </div>
                  <div className={classes.paso}>
                    <img src={WEB_ICON} className={classes.icon} />
                    <p className={classes.pasosText}>
                      Entra a 12tren.com y crea tu cuenta
                    </p>
                  </div>
                  <div className={classes.paso}>
                    <img src={DISCOUNT_ICON_2} className={classes.icon} />
                    <p className={classes.pasosText}>
                      Pon el código de descuento cuando contrates la membresía
                    </p>
                  </div>
                </div>
                <div className={classes.descuento}>
                  <p className={classes.descuentoText}>TU DESCUENTO ROKIN</p>
                  <p className={classes.descuentoText2}>34% Dcto.</p>
                  <p className={classes.descuentoText3}>
                    Canjea este código y consigue un 34% de descuento... ¡para
                    siempre!
                  </p>
                  {discountCode?.code === '' ? (
                    <p className={classes.descuentoText4}>
                      No hay codigos disponibles
                    </p>
                  ) : (
                    <p className={classes.descuentoText4}>
                      {discountCode?.code}
                    </p>
                  )}

                  <div className={classes.canjear} onClick={handleCopyButton}>
                    <img src={COPY_ICON} className={classes.icon} />
                    {copied ? (
                      <p className={classes.canjearText}>¡Copiado!</p>
                    ) : (
                      <p className={classes.canjearText}>Copiar código</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      ) : (
        <Dialog
          open={open}
          onClose={() => setOpen12Tren(false)}
          className={classes.Dialog}
          id='outer-div'
        >
          <div className={classes.container}>
            <div className={classes.bottomBackButtonContainer}>
              <img src={TREN_IMAGE} className={classes.image} />
              <div
                className={classes.closeButtonContainer}
                onClick={() => setOpen12Tren(false)}
              >
                <ArrowBackIosNewRoundedIcon className={classes.iconback} />
              </div>
            </div>
            <div className={classes.container2}>
              <p className={classes.titleText}>12tren.com</p>
              <p className={classes.infoText}>
                En 12tren podrás mejorar tu salud financiera
                <strong> comprando directamente a las fábricas</strong>, y
                evitando así los precios de supermercados. ¡Aquí podrás
                encontrar un descuento exclusivo por ser parte de la comunidad
                Rokin!
              </p>
              <div className={classes.descuentoConteiner}>
                <div className={classes.pasosContainer}>
                  <p className={classes.pasosText2}>
                    {' '}
                    ¿Cómo ocupo mi descuento Rokin?
                  </p>
                  <div className={classes.paso}>
                    <img src={COPY_ICON} className={classes.icon} />
                    <p className={classes.pasosText}>
                      Copia el código de descuento
                    </p>
                  </div>
                  <div className={classes.paso}>
                    <img src={WEB_ICON} className={classes.icon} />
                    <p className={classes.pasosText}>
                      Entra a 12tren.com y crea tu cuenta
                    </p>
                  </div>
                  <div className={classes.paso}>
                    <img src={DISCOUNT_ICON_2} className={classes.icon} />
                    <p className={classes.pasosText}>
                      Pon el código de descuento cuando contrates la membresía
                    </p>
                  </div>
                </div>
                <div className={classes.descuento}>
                  <p className={classes.descuentoText}>TU DESCUENTO ROKIN</p>
                  <p className={classes.descuentoText2}>34% Dcto.</p>
                  <p className={classes.descuentoText3}>
                    Canjea este código y consigue un 34% de descuento en el
                    primer pago de tu membresía trimestral o anual.
                  </p>
                  {discountCode?.code === '' ? (
                    <p className={classes.descuentoText4}>
                      No hay codigos disponibles
                    </p>
                  ) : (
                    <p className={classes.descuentoText4}>
                      {discountCode?.code}
                    </p>
                  )}
                  <div className={classes.canjear} onClick={handleCopyButton}>
                    <img src={COPY_ICON} className={classes.icon} />
                    <p className={classes.canjearText}>Copiar codigo</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};
